"use client";

import { Download, Loader2 } from "lucide-react";
import { useState } from "react";
import html2canvas from "html2canvas-pro";

interface ExportDashboardButtonProps {
    targetId: string;
}

export function ExportDashboardButton({ targetId }: ExportDashboardButtonProps) {
    const [isExporting, setIsExporting] = useState(false);

    const handleExport = async () => {
        console.log("Start Export Process");
        const element = document.getElementById(targetId);
        if (!element) {
            console.error(`Element with id ${targetId} not found`);
            alert("Error: Dashboard element not found");
            return;
        }

        setIsExporting(true);
        console.log("Exporting element:", element);

        try {
            await new Promise(resolve => setTimeout(resolve, 500)); // Increase wait time

            const canvas = await html2canvas(element, {
                backgroundColor: "#020617",
                scale: 2,
                logging: true, // Enable internal logging
                useCORS: true,
                allowTaint: true,
                ignoreElements: (element) => {
                    return element.hasAttribute("data-html2canvas-ignore");
                }
            });

            console.log("Canvas created", canvas);

            // Fallback to Blob if DataURL is failing for large images
            canvas.toBlob((blob) => {
                if (blob) {
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = `smokefree-dashboard-${new Date().toISOString().split('T')[0]}.png`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                    console.log("Download triggered");
                } else {
                    console.error("Blob creation failed");
                    alert("Failed to generate image file.");
                }
            }, 'image/png');

        } catch (error) {
            console.error("Export failed:", error);
            alert(`Export failed: ${error}`);
        } finally {
            setIsExporting(false);
        }
    };

    return (
        <div className="flex justify-center py-8" data-html2canvas-ignore>
            <button
                onClick={handleExport}
                disabled={isExporting}
                className="flex items-center gap-2 px-6 py-3 bg-slate-800 hover:bg-slate-700 text-slate-300 text-sm font-medium rounded-2xl transition-all shadow-lg shadow-black/20 hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
            >
                {isExporting ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />}
                {isExporting ? "กำลังบันทึกภาพ..." : "บันทึกหน้า Dashboard ทั้งหมด"}
            </button>
        </div>
    );
}
